import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IManualCreditCardPayment } from '../models/PaymentModel'

export class GetManualCreditCardPaymentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'manualCreditCardPayment/payment',
      requesterInfo,
    })
  }

  public async getManualCreditCardPayment(request: IManualCreditCardPayment): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
